import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createRef, Component } from "react";
import ReactModal from "react-modal";
import { cx } from "@emotion/css";
import { css } from "@emotion/react";
import { styled } from "../theme";
import { Icon } from "../icon";
import { H1, Text } from "../text";
import { Box } from "../box";
import { BlankButton } from "../button";
import { isMobile } from "../is-mobile";
if (process.env.NODE_ENV !== "test") {
    ReactModal.setAppElement("#root");
}
if (process.env.NODE_ENV === "test") {
    ReactModal.setAppElement("body");
}
// TODO: refactor to functional component
// TODO: use variables from theme in the components
export class Modal extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isOpen: this.props.isOpen,
        };
        this.triggerRef = createRef();
        this.closeModal = () => {
            if (this.props.onRequestClose) {
                this.props.onRequestClose();
            }
            this.setState({ isOpen: false });
        };
        this.openModal = () => this.setState({ isOpen: true });
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isOpen === undefined) {
            return null;
        }
        if (props.isOpen === state.isOpen) {
            return null;
        }
        return { isOpen: props.isOpen };
    }
    componentDidMount() {
        if (this.triggerRef.current) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            this.triggerRef.current.addEventListener("click", this.openModal);
        }
    }
    componentWillUnmount() {
        if (this.triggerRef.current) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            this.triggerRef.current.removeEventListener("click", this.openModal);
        }
    }
    render() {
        const { className, fullScreen, trigger, renderTrigger, title, size, noCloseButton, closeButtonPosition, topControls, children, Header, Title, CloseButton, Scrollable, Content, Footer, FooterButtons, ...modalProps } = this.props;
        const { isOpen } = this.state;
        const _trigger = trigger
            ? trigger(this.triggerRef)
            : renderTrigger
                ? renderTrigger({
                    openModal: this.openModal,
                    closeModal: this.closeModal,
                })
                : null;
        const commonClasses = {
            "is-fullscreen": fullScreen || isMobile,
            "is-window": !fullScreen || !isMobile,
        };
        return (_jsxs(_Fragment, { children: [_trigger, _jsx(ReactModal, { ...modalProps, 
                    // Keep custom classNames to not use the default styles
                    overlayClassName: cx("ReactModal__Overlay", size, commonClasses), className: cx("ReactModal__Content", size, commonClasses), isOpen: isOpen, onRequestClose: this.closeModal, children: _jsxs(ControlledContentRenderer, { shouldRerender: isOpen, children: [(title || topControls || noCloseButton !== true) && (_jsxs(Header, { children: [title && _jsx(Title, { children: title }), !noCloseButton && (_jsx(CloseButton, { onClick: this.closeModal, position: closeButtonPosition })), topControls] })), _jsx(Scrollable, { children: children({
                                    closeModal: this.closeModal,
                                    openModal: this.openModal,
                                    Content,
                                    Footer,
                                    FooterButtons,
                                }) })] }) })] }));
    }
}
Modal.defaultProps = {
    fullScreen: false,
    closeButtonPosition: "left",
    closeTimeoutMS: 500,
    Header: styled.div `
      width: 100%;
      min-height: 60px;
      margin: 0 auto;
      display: flex;
      flex-shrink: 0;
      align-items: baseline;
      justify-content: space-between;
      position: relative;
    `,
    Title: styled(H1) `
      margin: 25px 100px 25px 50px;
    `,
    CloseButton: styled(({ onClick, ...props }) => (_jsx(BlankButtonWithPosition, { ...props, onClick: onClick, children: _jsxs(Box, { flexDirection: "row", alignItems: "center", children: [_jsx(Icon, { name: "close", size: 22 }), _jsx(Text, { fontSize: 4, pt: 1, pl: 2, children: "Close" })] }) }))) `
      position: absolute;
      cursor: pointer;
      padding: ${({ theme }) => theme.space[3]}px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;

      i:before {
        display: block;
        margin: 0;
      }

      &:hover {
        opacity: 0.7;
      }
    `,
    Scrollable: styled((props) => (_jsx("div", { ...props, className: `${props.className} ReactModal__Scrollable` }))) `
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      overflow: auto;
      padding: ${({ theme }) => theme.space[3]}px ${({ theme }) => theme.space[2]}px;
      -webkit-overflow-scrolling: touch;

      ${({ theme }) => theme.media.md} {
        padding: ${({ theme }) => theme.space[4]}px
          ${({ theme }) => theme.space[3]}px;
      }
    `,
    Content: styled((props) => (_jsx("div", { ...props, className: `${props.className} ReactModal__InnerContent` }))) `
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      padding-bottom: 2em;

      ${({ theme }) => theme.media.md} {
        height: inherit;
      }
    `,
    Footer: styled((props) => (_jsx("div", { ...props, className: `${props.className} ReactModal__Footer` }))) `
      padding: 0;
    `,
    FooterButtons: styled((props) => (_jsx(Modal.defaultProps.Footer, { ...props, className: props.className }))) `
      display: flex;
      justify-content: flex-end;
      width: 100%;

      padding-top: ${({ theme }) => theme.space[4]}px;

      ${({ flexStart }) => flexStart &&
        css `
          justify-content: flex-start;
        `}

      > * {
        margin-left: 20px;
      }

      > *:first-of-type {
        margin-left: 0;
      }
    `,
};
class ControlledContentRenderer extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.shouldRerender;
    }
    render() {
        return this.props.children;
    }
}
const BlankButtonWithPosition = styled(BlankButton) `
  ${({ position }) => position === "left" &&
    css `
      left: 0;
    `}
  ${({ position }) => position === "right" &&
    css `
      right: 0;
    `}
`;
export const ModalContent = Modal.defaultProps.Content;
export const ModalFooter = Modal.defaultProps.Footer;
export const ModalFooterButtons = Modal.defaultProps.FooterButtons;
